import React, { memo, useRef, useReducer, isValidElement, cloneElement } from 'react';
import NotificationsContainerStyled from './bundle.esm3.js';
import Notification from './bundle.esm.js';
import { notificationsContainerReducer, initialState } from './bundle.esm4.js';
import useIsomorphicLayoutEffect from '../../hooks/bundle.esm.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NotificationsContainer = (props) => {
  const { top, left, right, bottom } = props;
  const notificationCount = useRef(0);
  const [state, dispatch] = useReducer(
    notificationsContainerReducer,
    initialState
  );
  const timersRefs = useRef({});
  const spawnNotification = (options) => {
    const { id = (++notificationCount.current).toString() } = options;
    dispatch({
      type: "ADD",
      payload: __spreadProps(__spreadValues({}, options), { id })
    });
  };
  const destroyNotification = () => {
    dispatch({
      type: "RESET"
    });
  };
  const dismissNotification = (id, position) => {
    dispatch({
      type: "REMOVE",
      payload: {
        id,
        position
      }
    });
  };
  const renderNotifications = (position) => {
    return state[position].map((notification, index) => {
      const { node, dismissOnClick = true, id, position: position2 } = notification;
      const { onClick, duration = 5e3 } = notification;
      if (!isValidElement(node))
        return null;
      let enhancedNode = node;
      const currentTimer = timersRefs.current[`${position2}-${id}`];
      if (duration && duration > 0 && !currentTimer) {
        const timer = setTimeout(() => {
          Notification.dismiss(id, position2);
          clearTimeout(timersRefs.current[`${position2}-${id}`]);
          delete timersRefs.current[`${position2}-${id}`];
        }, duration);
        timersRefs.current[`${position2}-${id}`] = timer;
      }
      const clickHandler = (e) => {
        onClick == null ? void 0 : onClick(e);
        if (!dismissOnClick)
          return;
        Notification.dismiss(id, position2);
      };
      if (typeof node.type !== "string") {
        enhancedNode = cloneElement(node, {
          dismiss: () => Notification.dismiss(id, position2)
        });
      }
      return /* @__PURE__ */ React.createElement("div", {
        key: index,
        className: "NotificationsContainer__item",
        onClick: clickHandler
      }, enhancedNode);
    });
  };
  useIsomorphicLayoutEffect(() => {
    Notification.register({
      create: spawnNotification,
      destroy: destroyNotification,
      dismiss: dismissNotification
    });
  }, []);
  return /* @__PURE__ */ React.createElement(NotificationsContainerStyled, {
    className: "NotificationsContainer",
    top,
    left,
    right,
    bottom
  }, /* @__PURE__ */ React.createElement("div", {
    className: "NotificationsContainer__container NotificationsContainer__container--top-left"
  }, renderNotifications("top-left")), /* @__PURE__ */ React.createElement("div", {
    className: "NotificationsContainer__container NotificationsContainer__container--top-right"
  }, renderNotifications("top-right")), /* @__PURE__ */ React.createElement("div", {
    className: "NotificationsContainer__container NotificationsContainer__container--top-center"
  }, renderNotifications("top-center")), /* @__PURE__ */ React.createElement("div", {
    className: "NotificationsContainer__container NotificationsContainer__container--bottom-left"
  }, renderNotifications("bottom-left")), /* @__PURE__ */ React.createElement("div", {
    className: "NotificationsContainer__container NotificationsContainer__container--bottom-right"
  }, renderNotifications("bottom-right")), /* @__PURE__ */ React.createElement("div", {
    className: "NotificationsContainer__container NotificationsContainer__container--bottom-center"
  }, renderNotifications("bottom-center")));
};
NotificationsContainer.defaultProps = {};
var NotificationsContainer$1 = memo(NotificationsContainer);

export { NotificationsContainer$1 as default };
//# sourceMappingURL=bundle.esm2.js.map
